import { OrchestrationBQAuthType } from '@common/Fabric/types/orchestration';
import { useProviderForm } from '@pages/Fabric/common/ProviderFormContext';
import { UnifiedBigQueryFormData } from '@pages/Fabric/types';
import { UseFormReturn } from 'react-hook-form';

import { AuthStateCard } from '../AuthCard';
import { ReadOnlyFabricView, ReadOnlySection } from '../ReadOnlyFabricView';
import { getAuthBadge, hasAuthStateCard } from '../utils';

export const BigQueryReadOnlyView = () => {
  const { formContext, fabricAuthState } = useProviderForm();
  const bqFormContext = formContext as unknown as UseFormReturn<UnifiedBigQueryFormData>;
  const unifiedFabricData = bqFormContext.watch('unifiedFabricData');

  if (!unifiedFabricData) {
    return null;
  }

  const isOAuth = unifiedFabricData.authType === OrchestrationBQAuthType.OAuth;
  const showAuthSection = isOAuth || hasAuthStateCard(fabricAuthState ?? null);

  const sections: ReadOnlySection[] = [
    {
      rows: [
        { label: 'Project ID', value: unifiedFabricData.projectId },
        { label: 'Prophecy Dataplane URL', value: unifiedFabricData.dataplaneURL }
      ]
    },
    ...(showAuthSection
      ? [
          {
            title: 'Authentication',
            badge: fabricAuthState ? getAuthBadge(fabricAuthState) : undefined,
            content: <AuthStateCard authState={fabricAuthState ?? null} provider='BigQuery' />
          }
        ]
      : []),
    {
      title: 'BigQuery Warehouse',
      badge: { label: 'Configured', variant: 'success' },
      rows: [
        { label: 'Dataset', value: unifiedFabricData.dataset },
        { label: 'Bucket Name', value: unifiedFabricData.bucketName },
        { label: 'KMS Key', value: unifiedFabricData.kmsKey }
      ]
    }
  ];

  return <ReadOnlyFabricView sections={sections} />;
};
